import { AfterContentInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';


@Directive({
	selector: '[vtrAutoFocus],[autofocus]'
})
export class AutofocusDirective implements AfterContentInit, OnChanges {

	private focus = true;
	private element: HTMLElement;
	private hadTabIndex = true;
	private readonly TAB_INDEX = 'tabindex';

	constructor(private el: ElementRef) {
		try {
			this.element = this.el.nativeElement;
		}
		catch (error) {

		}

	}
	ngOnChanges(changes: SimpleChanges): void {

		try {
			if (changes.autofocus.currentValue) {
				this.focusElement();
			}

		} catch (error) {
		}
	}

	private focusElement() {
		try {
			if (this.focus) {

				if (!this.element.hasAttribute(this.TAB_INDEX)) {
					this.hadTabIndex = false;
					this.element.setAttribute(this.TAB_INDEX, '0');
				}

				window.setTimeout(() => {
					// Added to reposition narrator focus position during hide and show.
					/* let activeElement = document.activeElement as HTMLElement;
					activeElement.blur(); */

					this.element.addEventListener('blur', this.handleBur.bind(this));
					this.element.focus();


				}, 100);
			}
		}
		catch (error) {

		}
	}
	private handleBur() {
		try {
			if (!this.hadTabIndex) {
				this.element.removeAttribute(this.TAB_INDEX);
			}
		} catch (error) {
		}


	}

	@Input() set autofocus(condition: boolean) {
		this.focus = condition !== false;
	}

	public ngAfterContentInit() {
		try {
			this.focusElement();
		} catch (error) {
		}

	}

}
